import { destructureAxiosReq } from '../services/utils';
import sureAxios from '../services/sureAxios';
import axios from 'axios';
import md5 from 'blueimp-md5';
import each from 'lodash/each';

/**
 * Sign a file for S3 upload.
 *
 * @param {Object} opts The options.
 * @param {File} opts.file The file to be uploaded.
 * @param {String} opts.description The file description.
 * @param {String} opts.authToken The auth token.
 * @return {Object} The signing information.
 */
export function awsSignFile(opts = {}) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const fileAsBinaryString = reader.result;
      const md5Hash = md5(fileAsBinaryString);

      destructureAxiosReq(
        sureAxios.post(
          `${process.env.REACT_APP_SURE_API_BASE_URL}/api/management/v1/files/sign`,
          {
            content_type: opts.file.type,
            file_hash: md5Hash,
            file_name: opts.file.name,
            description: opts.description,
          },
          {
            headers: {
              Authorization: `Bearer ${opts.authToken}`,
            },
          }
        )
      ).then(resolve, reject);
    };
    reader.onabort = () => console.error('file reading was aborted');
    reader.onerror = () => console.error('file reading has failed');
    reader.readAsBinaryString(opts.file);
  });
}

/**
 * Upload a signed file to AWS.
 *
 * @param {File} file The file to upload.
 * @param {*} signingObj  The AWS signed file response.
 */
export function awsUploadSignedFile(file, signingObj) {
  const form = new FormData();
  const url = signingObj.s3_request.url;

  each(signingObj.s3_request.post, (val, key) => {
    form.append(key, val);
  });
  form.append('file', file);
  return axios.post(url, form, {
    headers: {
      'Content-Type': file.type,
    },
    transformRequest: [
      (data, headers) => {
        /**
         * XXX: Delete default `headers` manually until Axios 0.19 release,
         * which keeps `defaults` local to instance
         * https://github.com/axios/axios/pull/1395
         */
        delete headers['X-Space'];
        delete headers['Authorization'];
        return data;
      },
    ],
  });
}

/**
 * Submit file for bulk CSV operation.
 *
 * @param {String} fileApprovalId  The Amazon S3 signed file approval ID.
 * @param {String} authToken The Sure API auth token.
 */
export function submitBulkCSVUpload(fileApprovalId, authToken) {
  return destructureAxiosReq(
    sureAxios.post(
      `${process.env.REACT_APP_SURE_API_BASE_URL}/api/management/v1/clients/bulk-csv`,
      {
        file_approval_id: fileApprovalId,
      },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
  );
}

/**
 * Gets the status of a long running operation.
 *
 * @param {String} fileApprovalId  The Amazon S3 signed file approval ID.
 * @param {String} authToken The Sure API auth token.
 */
export function getLongOperationStatus(longOperationId, authToken) {
  return destructureAxiosReq(
    sureAxios.get(
      `${process.env.REACT_APP_SURE_API_BASE_URL}/api/management/v1/long_operations/${longOperationId}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
  );
}
